'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _desc, _value, _class2, _descriptor;

var _templateObject = _taggedTemplateLiteral(['\n  padding: 10px;\n  overflow: scroll;\n  height: 100%;\n'], ['\n  padding: 10px;\n  overflow: scroll;\n  height: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  background: rgb(247, 247, 247);\n  border: 1px solid rgb(193, 193, 193);\n  border-radius: 2px;\n  color: rgb(130, 130, 130);\n  display: block;\n  text-transform: uppercase;\n  text-align: center;\n  text-decoration: none;\n  letter-spacing: 1.5px;\n  margin-bottom: 10px;\n  font-weight: bolder;\n  font-size: 12px;\n  padding: 5px;\n'], ['\n  background: rgb(247, 247, 247);\n  border: 1px solid rgb(193, 193, 193);\n  border-radius: 2px;\n  color: rgb(130, 130, 130);\n  display: block;\n  text-transform: uppercase;\n  text-align: center;\n  text-decoration: none;\n  letter-spacing: 1.5px;\n  margin-bottom: 10px;\n  font-weight: bolder;\n  font-size: 12px;\n  padding: 5px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  border-bottom: 1px solid rgb(238, 238, 238);\n  margin-bottom: 10px;\n  padding-bottom: 10px;\n'], ['\n  border-bottom: 1px solid rgb(238, 238, 238);\n  margin-bottom: 10px;\n  padding-bottom: 10px;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  color: rgb(130, 130, 130);\n  font-size: .85em;\n  padding: 5px;\n  width: 100%;\n'], ['\n  color: rgb(130, 130, 130);\n  font-size: .85em;\n  padding: 5px;\n  width: 100%;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  list-style-type: none;\n  padding: 0;\n'], ['\n  list-style-type: none;\n  padding: 0;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  border-bottom: 1px solid rgb(238, 238, 238);\n'], ['\n  border-bottom: 1px solid rgb(238, 238, 238);\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  cursor: pointer;\n  display: block;\n  font-weight: ', ';\n  padding: ', ';\n'], ['\n  cursor: pointer;\n  display: block;\n  font-weight: ', ';\n  padding: ', ';\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  border-bottom: none;\n  font-size: .85em;\n  padding: 7px 0px 0px 7px;\n\n  &:last-child {\n    padding-bottom: 7px;\n  }\n'], ['\n  border-bottom: none;\n  font-size: .85em;\n  padding: 7px 0px 0px 7px;\n\n  &:last-child {\n    padding-bottom: 7px;\n  }\n']);

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _reduce = require('lodash/reduce');

var _reduce2 = _interopRequireDefault(_reduce);

var _sortBy = require('lodash/fp/sortBy');

var _sortBy2 = _interopRequireDefault(_sortBy);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SidebarContainer = _styledComponents2.default.div(_templateObject);

var ProjectName = _styledComponents2.default.a(_templateObject2);

var FilterContainer = _styledComponents2.default.div(_templateObject3);

var FilterInput = _styledComponents2.default.input(_templateObject4);

var StoriesList = _styledComponents2.default.ul(_templateObject5);

var ParentContainer = _styledComponents2.default.li(_templateObject6);

var SelectParent = _styledComponents2.default.span(_templateObject7, function (props) {
  return props.selected ? 'bold' : 'normal';
}, function (props) {
  return props.selected ? '7px 0 0 0' : '7px 0px';
});

var StoryContainer = SelectParent.extend(_templateObject8);

var sortStories = (0, _sortBy2.default)('parentName');

var Sidebar = (0, _mobxReact.observer)(_class = (_class2 = function (_Component) {
  _inherits(Sidebar, _Component);

  function Sidebar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Sidebar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'filterValue', _descriptor, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Sidebar, [{
    key: 'renderFilter',
    value: function renderFilter() {
      var _this2 = this;

      return _react2.default.createElement(FilterInput, {
        type: 'text',
        placeholder: 'Filter',
        value: this.filterValue,
        onChange: function onChange(_ref2) {
          var value = _ref2.target.value;

          _this2.filterValue = value;
        }
      });
    }
  }, {
    key: 'renderStories',
    value: function renderStories() {
      var devNovelInstance = this.props.devNovelInstance;


      return this.stories.map(function (_ref3) {
        var parentStories = _ref3.parentStories,
            parentName = _ref3.parentName;

        var isSelected = devNovelInstance.selectedStory.split('.')[0] === parentName;
        return _react2.default.createElement(
          ParentContainer,
          { key: parentName },
          _react2.default.createElement(
            SelectParent,
            {
              selected: isSelected,
              onClick: function onClick() {
                return devNovelInstance.selectParent(parentName);
              }
            },
            parentName
          ),
          devNovelInstance.openAllStories || isSelected ? (0, _map2.default)(parentStories, function (storyFn, storyName) {
            return _react2.default.createElement(
              StoryContainer,
              {
                key: parentName + '.' + storyName,
                selected: devNovelInstance.selectedStory === parentName + '.' + storyName,
                onClick: function onClick() {
                  return devNovelInstance.selectStory(parentName + '.' + storyName);
                }
              },
              storyName
            );
          }) : null
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var project = this.props.devNovelInstance.project;


      return _react2.default.createElement(
        SidebarContainer,
        null,
        _react2.default.createElement(
          ProjectName,
          { href: project.link, target: '_default' },
          project.name
        ),
        _react2.default.createElement(
          FilterContainer,
          null,
          this.renderFilter()
        ),
        _react2.default.createElement(
          StoriesList,
          null,
          this.renderStories()
        )
      );
    }
  }, {
    key: 'stories',
    get: function get() {
      var stories = this.props.devNovelInstance.stories;

      var filterValue = this.filterValue.toLowerCase();

      if (filterValue && filterValue.trim()) {
        return sortStories((0, _reduce2.default)(stories, function (result, parentStories, parentName) {
          var isParentNameMatch = parentName.toLowerCase().includes(filterValue);
          var isChildrenStoryMatch = Object.keys(parentStories).some(function (storyName) {
            return storyName.toLowerCase().includes(filterValue);
          });

          return isParentNameMatch || isChildrenStoryMatch ? [].concat(_toConsumableArray(result), [{ parentName: parentName, parentStories: parentStories }]) : result;
        }, []));
      }

      return sortStories((0, _reduce2.default)(stories, function (result, parentStories, parentName) {
        return [].concat(_toConsumableArray(result), [{ parentName: parentName, parentStories: parentStories }]);
      }, []));
    }
  }]);

  return Sidebar;
}(_react.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'filterValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'stories', [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, 'stories'), _class2.prototype)), _class2)) || _class;

exports.default = Sidebar;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dev-novel/dist/ui/sidebar.js
// module id = 377
// module chunks = 0